import Button from '@mui/material/Button';
import { hexWithOpacity } from 'common/utils';
import { colors } from 'styles/colors';
import useStyles from './styles';
import Circle from 'components/common/Circle/Circle';
import CustomText from 'components/common/CustomText/CustomText';

interface Props {
  graphSyncedAt: string | null;
  graphOutdated: boolean;
}

// Whether the knowledge graph holds this product as it stands, drawn the way the
// publish state is drawn beside it.
//
// Three states rather than two, and the third is the one worth seeing: Outdated
// is the graph holding the product, but not this version of it. Which version it
// holds is answered on the server, by comparing what the last sync sent against
// what a sync would send now - an edit the graph has no room for leaves this
// Synced.
export default function GraphStatus({ graphSyncedAt, graphOutdated }: Props) {
  const styles = useStyles();

  const synced = Boolean(graphSyncedAt);
  const outdated = synced && graphOutdated;

  const color = !synced ? colors.error : outdated ? colors.warning : colors.success;
  const label = !synced ? 'Not synced' : outdated ? 'Outdated' : 'Synced';

  return (
    <div>
      <Button
        className={styles.statusOuterButton}
        sx={{
          paddingLeft: 0,
          backgroundColor: hexWithOpacity(color, 0.1),
          color: color,
          '&&:hover': {
            bgcolor: hexWithOpacity(color, 0.3),
            color: color,
          },
        }}
      >
        <Circle
          boxSize={20}
          circleSize={6}
          color={color}
        />
        <CustomText text={label} color={color} fontSize={14} />
      </Button>
    </div>
  );
}
